import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Option } from '@digilize/shared/definitions/src';
import { TranslateService } from '@ngx-translate/core';
import { Company } from '../../models/company.model';
import { CompanyMockService } from '../../services/company-mock.service';

@Component({
  selector: 'bwc-companies-for-you',
  templateUrl: './companies-for-you.component.html',
  styleUrls: ['./companies-for-you.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CompaniesForYouComponent implements OnInit {
  companies: Company[] = [];
  visibleCount = 30;
  followedIds: number[] = [];
  locationSearch = 'Sittard';
  distanceFilter = '10';

  distanceControl = new FormControl('10');
  fieldsControl = new FormControl('');
  sectorsControl = new FormControl('');
  languagesControl = new FormControl('');
  employeesControl = new FormControl('');

  distanceOptions: Option[] = [];
  fieldsOptions: Option[] = [];
  sectorsOptions: Option[] = [];
  languagesOptions: Option[] = [];
  employeesOptions: Option[] = [];

  constructor(
    private companyService: CompanyMockService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.companyService.getCompanies().subscribe(c => (this.companies = c));
    this.followedIds = this.companyService.getFollowedIds();

    this.distanceOptions = [
      { text: '5 km', val: '5' },
      { text: '10 km', val: '10' },
      { text: '25 km', val: '25' },
      { text: '50 km', val: '50' },
      { text: '100 km', val: '100' },
    ];
    this.fieldsOptions = [
      { text: this.translateService.instant('companies.for_you.filter_all_fields'), val: '' },
    ];
    this.sectorsOptions = [
      { text: this.translateService.instant('companies.for_you.filter_all_sectors'), val: '' },
    ];
    this.languagesOptions = [
      { text: this.translateService.instant('companies.for_you.filter_all_languages'), val: '' },
    ];
    this.employeesOptions = [
      { text: this.translateService.instant('companies.for_you.filter_all_employees'), val: '' },
    ];
  }

  get visibleCompanies(): Company[] {
    return this.companies.slice(0, this.visibleCount);
  }

  get hasMore(): boolean {
    return this.visibleCount < this.companies.length;
  }

  loadMore(): void {
    this.visibleCount = Math.min(this.visibleCount + 30, this.companies.length);
  }

  isFollowed(id: number): boolean {
    return this.followedIds.includes(id);
  }

  toggleFollow(company: Company): void {
    const followed = this.companyService.toggleFollowCompany(company);
    this.followedIds = followed
      ? [...this.followedIds, company.id]
      : this.followedIds.filter(id => id !== company.id);
  }

  onDistanceSelected(option: Option): void {
    this.distanceFilter = option.val;
  }

  onFieldsSelected(option: Option): void {}

  onSectorsSelected(option: Option): void {}

  onLanguagesSelected(option: Option): void {}

  onEmployeesSelected(option: Option): void {}
}
